// Вспомогательные функции для работы с активами

// Универсальная функция для форматиров  console.log('📤 prepareAssetForSave выход:', preparedAsset);ния цен
export const formatPrice = (price) => {
  if (!price && price !== 0) return "";
  return parseFloat(price).toFixed(2);
};

// Функция для форматирования валюты
export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return "0 ₽";
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// Функция для форматирования даты в формат YYYY-MM-DD для input[type="date"]
export const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error('Ошибка форматирования даты:', error);
    return "";
  }
};

// Функция для генерации уникального ключа
export const generateUniqueKey = (existingKeys, baseName = "новый_параметр") => {
  let counter = 1;
  let newKey = baseName;
  while (existingKeys.includes(newKey)) {
    newKey = `${baseName}_${counter}`;
    counter++;
  }
  return newKey;
};

// Функция для валидации актива
export const validateAsset = (asset) => {
  const errors = [];
  
  if (!asset.name?.trim()) {
    errors.push("Название актива обязательно");
  }
  for (const [field, label] of [['deposit', 'Залог'], ['purchase_price', 'Цена покупки']]) {
    const value = asset[field];
    if (value != null && value !== '' && (!Number.isFinite(Number(value)) || Number(value) < 0)) {
      errors.push(`${label}: укажите неотрицательную сумму`);
    }
  }
  
  return errors;
};

// Функция для подготовки данных актива для отправки на сервер
export const prepareAssetForSave = (asset) => {
  console.log('🔄 prepareAssetForSave вход:', asset);
  
  // Убираем лишние поля, которых нет в backend
  const { 
    id,
    created_at,
    updated_at,
    owner_id,
    current_deal_id,
    courier_handover,
    asset_number,
    company_id,
    founder_id,
    manager_id,
    rental_point,  // Убираем объект rental_point
    asset_status,  // Убираем объект asset_status
    selected_tariff, // Убираем объект selected_tariff
    technical_specifications, // Убираем frontend поле, т.к. будем маппить в specifications
    ...cleanAsset 
  } = asset;

  // Готовим данные для отправки
  const preparedAsset = {
    ...cleanAsset,
    // Числовые поля
    deposit: asset.deposit ? parseFloat(asset.deposit) : 0,
    purchase_price: asset.purchase_price ? parseFloat(asset.purchase_price) : 0,
    purchase_date: asset.purchase_date || null,
    maintenance_due_date: asset.maintenance_due_date || null,
    
    // ID поля как числа
    asset_status_id: asset.asset_status_id ? parseInt(asset.asset_status_id) : null,
    rental_point_id: asset.rental_point_id ? parseInt(asset.rental_point_id) : null,
    locker_cell_id: asset.locker_cell_id ? parseInt(asset.locker_cell_id) : null,
    tariff_id: asset.tariff_id ? parseInt(asset.tariff_id) : null,
    
    // ИСПРАВЛЕНИЕ: Правильный маппинг technical_specifications -> specifications для backend
    specifications: asset.technical_specifications || asset.specifications || {},
    search_metadata: {
      ...Object.fromEntries(Object.entries(asset.search_metadata || {}).filter(([key]) => key !== 'tags')),
      target_audience: asset.search_metadata?.target_audience || [],
      use_cases: asset.search_metadata?.use_cases || []
    },
    ai_tags: asset.search_metadata?.tags || asset.ai_tags || []
  };

  console.log('� prepareAssetForSave выход:', preparedAsset);
  
  return preparedAsset;
};
